import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      shark: {
        primary: '#1F1E33', // These are misleading!!! Colors are being passed from the DB and set in account/setCurrentClient
        secondary: '#607D8B',
        accent: '#40C4FF',
        error: '#FF0041',
        info: '#2A81FF',
        success: '#30D88E',
        warning: '#FFC40A',
      },
      commercialCar: {
        primary: '#7F7D7D',
        secondary: '#00B2E3',
        accent: '#0F0F0F',
        error: '#F70042',
        info: '#165EFF',
        success: '#0CFB92',
        warning: '#FFC100',
      },
      avis: {
        secondary: '#0F0F0F',
        primary: '#D4002A',
        accent: '#3887B7',
        error: '#FF0041',
        info: '#2A81FF',
        success: '#30D88E',
        warning: '#FFC40A',
      },
      light11: {
        primary: '#1F1E33',
        secondary: '#607D8B',
        accent: '#F5F6FA',
        error: '#FF0041',
        info: '#2A81FF',
        success: '#30D88E',
        warning: '#FFC40A',
      },
    },
  },
  breakpoint: {
    thresholds: {
      xs: 200,
      sm: 540,
      md: 960,
      lg: 1250,
      xl: 2000,
    },
    scrollBarWidth: 24,
  },
  options: {
    customProperties: true,
  },
});
